import { AddBox } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import SimpleText from "./SimpleText";

const InfoBox = ({ content, image }) => {
  const isPad = useMediaQuery("(max-width:900px)");

  return (
    <Box
      sx={{
        boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
        borderRadius: { xs: "5vw", sm: "5vw", md: "5vw", lg: "20px" },
        position: "relative",
        padding: { xs: "10%", sm: "10%", md: "10%", lg: "28px" },
        margin: {
          xs: "1.5% 1.5% 3% 1.5%",
          sm: "1.5% 1.5% 3% 1.5%",
          md: "1.5% 1.5% 3% 1.5%",
          lg: "0.8%",
        },
        width: { xs: "100%", sm: "100%", md: "100%", lg: "370px" },
        height: { xs: "auto", sm: "auto", md: "auto", lg: "340px" },
      }}
    >
      <Typography
        sx={{
          marginBottom: "2%",
          marginTop: "2%",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "13px",
              md: "3.5vw",
              lg: "30px",
            },
            marginLeft: { xs: "15%", sm: "15%", md: "12%", lg: "0" },
            marginBottom: { xs: "3%", sm: "3%", md: "3%", lg: "2%" },
            fontWeight: "500",
            color: "#09507F",
          }}
          variant="body2"
        >
          {content?.header}
        </Typography>
        <SimpleText
          style={{
            fontSize: { xs: "13px", sm: "3.5vw", md: "3.3vw", lg: "20px" },
            color: "#2f2f2f",
            paddingBottom: "20px",
          }}
          text={content?.subheader}
        />
      </Typography>
      <img
        style={
          !isPad
            ? { position: "absolute", bottom: "3%", right: "8%" }
            : {
                position: "absolute",
                top: "10%",
                left: "8%",
              }
        }
        width={!isPad ? "40px" : "8%"}
        src={image}
      />
    </Box>
  );
};

export default InfoBox;
